export class Logout {
	constructor (login) {
		this._login = login
	}

	setVisible = visible => {
		if (visible) {
			this._login.logout()
		}
	}
}